import AssetDocuments from "../components/AssetDocuments";


const AssetDocumentsPage = () => {
  return (
    <section className="">
      {/* <TopMenuStrip /> */}
     <AssetDocuments/>
    </section>
  );
};

export default AssetDocumentsPage;